import React from 'react';
// import PropTypes from 'prop-types';
import { Link as MuiLink } from '@material-ui/core';
// import classes from './Link.module.scss';

const Link = (props) => {
  const {
    className,
    text,
    linkProps: { onClick, ...others },
  } = props;

  const preventDefault = (event) => event.preventDefault();

  const handleClick = (event) => {
    if (onClick) onClick();
    preventDefault(event);
  };

  return (
    <MuiLink className={className} onClick={handleClick} {...others}>
      {text}
    </MuiLink>
  );
};

Link.propTypes = {};

export default Link;
